module.exports = __webpack_public_path__ + "img/logo.12ae4388.png";